import React from 'react'
import { type IconProps } from '../IconPropsInterface'

export const ChevronLeftLarge: React.FC<IconProps> = ({
  color,
  size,
  fill,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 4L8 11.5L15.5 19"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
